import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../store/slices/auth/slice';
import commonSlice from '../store/slices/common/slice';
import userSlice from '../store/slices/user/slice';
import deliverySlice from '../store/slices/delivery/slice';
import partnersSlice from '../store/slices/partners/slice';
import orderSlice from '../store/slices/order/slice';
import inventorySlice from '../store/slices/inventory/slice';

import { api } from './api';

const store = configureStore({
  reducer: {
    auth: authSlice,
    userInfo: userSlice,
    deliveryInfo: deliverySlice,
    commonInfo: commonSlice,
    partnersInfo: partnersSlice,
    orderInfo: orderSlice,
    inventoryInfo: inventorySlice,

    [api.reducerPath]: api.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware),
  devTools: true,
});

export default store;
